import script from "./Topic.vue?vue&type=script&setup=true&lang=ts"
export * from "./Topic.vue?vue&type=script&setup=true&lang=ts"

import "./Topic.vue?vue&type=style&index=0&id=64678694&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64678694"]])

export default __exports__